import { Cols } from "../../shared/Consts";
import { Transaction } from "../../models/Transaction";
import usePortfolio from "../../hooks/PortfolioProvider";
import { usePath } from "../../libs/path/PathProvider";
import PortUtils from "../../portlibs/PortUtils";
import HistoryTitle from "./HistoryTitle";
import _ from "lodash";
import { CashTransaction } from "../../models/CashTrasanction";
import HistoryFilter, { useHistoryFilter } from "../../components/HistoryFilter";
import TransactionTable from "../../components/TransactionTable";
import SummaryCash from "./SummaryCash";
import { IHistoryProps } from "../History";

const COLS = [Cols.date, Cols.accountId, Cols.type, Cols.total, Cols.balance, Cols.note]

export default function CashHistory(props:IHistoryProps){
    const {query} = usePath();
    const {portfolio} = usePortfolio()
    const account = PortUtils.getFilter(query).account
    
    const holding = portfolio.holding(props.ticker)!.filterByAccount(account)
    const historyFilter = useHistoryFilter()

    const {transactions,rows} = PortUtils.excludeFilter(holding.transactions.slice(0), historyFilter)

    const startBalance : Record<string,number> = {}
    const endBalance : Record<string,number> = {}
    let balance = 0
    for(const row of transactions as CashTransaction[]){
        startBalance[row._id] = balance
        balance += row.quantity * row.price
        endBalance[row._id] = balance
    }

    const value = (row:Transaction, col:string) => col=="balance" ? PortUtils.formatCurrency(holding.currency, endBalance[row.id]) : row.value(col)
    let open = "", close = ""
    if (rows.length) {
        open = PortUtils.formatCurrency(holding.currency, startBalance[rows[0]._id])
        close = PortUtils.formatCurrency(holding.currency, endBalance[rows[rows.length-1]._id])
    }

    const balanceSorter = (dir:number) => (l:Transaction, r:Transaction) => dir*(endBalance[l._id] - endBalance[r._id])
    const sorter = (col:string, dir:number) => col=="balance" ? balanceSorter(dir) : PortUtils.transSorter(col, dir)

    const table = <TransactionTable classNames={{flex1:true}} tableName="trans" {...props} rows={rows} cols={COLS} infiniteScroll={true} holding={holding} value={value} sorter={sorter}/>
    return <>
        <HistoryTitle holding={holding} transactions={rows} cols={COLS}/>
        <SummaryCash holding={holding} openBalance={open} closeBalance={close}/>
        <div className="flex gap-8 flex-wrap"><HistoryFilter/></div>
        {table}
    </>
}
